@switch (kind) {
  @case ('story') {
    <app-atlas-story-skeleton />
  }
  @case ('view') {
    <app-atlas-grid-skeleton [guestView]="userStore.isGuestView()" />
  }
  @default {
    <app-atlas-landingpage-skeleton />
  }
}
